import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../../../Button.js';
import Modal from '../../../Modal.js';
import Fogedbegaering from '../../CreateTribunalCase/types/Fogedbegaering.js';
const ResendFogedBegaering = (props) => {
    const lang = useSelector((s) => s.lang);
    const [modalOpen, setModalOpen] = useState(false);
    const lastJob = props.pastJobs[0];
    return (React.createElement("div", null,
        React.createElement(Button, { onClick: () => setModalOpen(true) }, lang.tribunal.editFogedbegaering),
        modalOpen && (React.createElement(Modal, { header: lang.tribunal.resendFogedbegaering, onToggle: () => setModalOpen(false) },
            React.createElement(Fogedbegaering, { caseSequentialId: props.caseSeqId, tenantId: props.tenantId, tribunalCaseId: props.tribunalCase.id, resending: true, prefill: {
                    ...lastJob.data,
                    addCourtDisbursementToClientBilling: false,
                    addCourtFeeToCase: false,
                    addCourtFeeToClientBilling: false,
                    sendInfoToEconomyResponsible: false,
                }, onCreated: () => {
                    setModalOpen(false);
                } })))));
};
export default ResendFogedBegaering;
//# sourceMappingURL=ResendFogedBegaering.js.map